// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer_HhFdD","columnHeader":"Footer_columnHeader_QvQZ3","items":"Footer_items_mHGQH"};